import {
  createFetchActionForNamespace,
  createPostActionForNamespace,
  createReducer,
  createFetchReducers,
  createPostReducers,
  createFetchSelectors,
  createPostSelectors
} from 'utils/reducers';

import {SCHEDULE_TYPES} from 'ducks/tenancy';

const createFetchAction = createFetchActionForNamespace('tenancy/detail');
const createPostAction = createPostActionForNamespace('tenancy/detail');

export const FETCH_SCHEDULE_DELAY = 5000;
export const FETCH_GC_PAYMENT_DELAY = 3000;

// TODO: Revisit Break Clauses. Maybe delete them.
export const RECORD_BREAK_CLAUSE_NOTICE =
  'tenancy/detail/RECORD_BREAK_CLAUSE_NOTICE';
export const RECORD_BREAK_CLAUSE_NOTICE_SUCCESS =
  'tenancy/detail/RECORD_BREAK_CLAUSE_NOTICE_SUCCESS';
export const RECORD_BREAK_CLAUSE_NOTICE_FAILURE =
  'tenancy/detail/RECORD_BREAK_CLAUSE_NOTICE_FAILURE';

export const INITIATE_GOCARDLESS_PAYMENT =
  'tenancy/detail/INITIATE_GOCARDLESS_PAYMENT';
export const INITIATE_GOCARDLESS_PAYMENT_SUCCESS =
  'tenancy/detail/INITIATE_GOCARDLESS_PAYMENT_SUCCESS';
export const INITIATE_GOCARDLESS_PAYMENT_FAILURE =
  'tenancy/detail/INITIATE_GOCARDLESS_PAYMENT_FAILURE';

export const FILTER_GOCARDLESS_CUSTOMERS =
  'tenancy/detail/FILTER_GOCARDLESS_CUSTOMERS';
export const FILTER_GOCARDLESS_CUSTOMERS_SUCCESS =
  'tenancy/detail/FILTER_GOCARDLESS_CUSTOMERS_SUCCESS';
export const FILTER_GOCARDLESS_CUSTOMERS_FAILURE =
  'tenancy/detail/FILTER_GOCARDLESS_CUSTOMERS_FAILURE';

export const FILTER_GOCARDLESS_ACTIVE_MANDATES =
  'tenancy/detail/FILTER_GOCARDLESS_ACTIVE_MANDATES';
export const FILTER_GOCARDLESS_ACTIVE_MANDATES_SUCCESS =
  'tenancy/detail/FILTER_GOCARDLESS_ACTIVE_MANDATES_SUCCESS';
export const FILTER_GOCARDLESS_ACTIVE_MANDATES_FAILURE =
  'tenancy/detail/FILTER_GOCARDLESS_ACTIVE_MANDATES_FAILURE';

export const FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS =
  'tenancy/detail/FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS';
export const FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS_SUCCESS =
  'tenancy/detail/FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS_SUCCESS';
export const FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS_FAILURE =
  'tenancy/detail/FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS_FAILURE';

export const CONNECT_GOCARDLESS_CUSTOMER =
  'tenancy/detail/CONNECT_GOCARDLESS_CUSTOMER';
export const CONNECT_GOCARDLESS_CUSTOMER_SUCCESS =
  'tenancy/detail/CONNECT_GOCARDLESS_CUSTOMER_SUCCESS';
export const CONNECT_GOCARDLESS_CUSTOMER_FAILURE =
  'tenancy/detail/CONNECT_GOCARDLESS_CUSTOMER_FAILURE';

export const CANCEL_GOCARDLESS_PAYMENT =
  'tenancy/detail/CANCEL_GOCARDLESS_PAYMENT';
export const CANCEL_GOCARDLESS_PAYMENT_SUCCESS =
  'tenancy/detail/CANCEL_GOCARDLESS_PAYMENT_SUCCESS';
export const CANCEL_GOCARDLESS_PAYMENT_FAILURE =
  'tenancy/detail/CANCEL_GOCARDLESS_PAYMENT_FAILURE';

export const RETRY_GOCARDLESS_PAYMENT =
  'tenancy/detail/RETRY_GOCARDLESS_PAYMENT';
export const RETRY_GOCARDLESS_PAYMENT_SUCCESS =
  'tenancy/detail/RETRY_GOCARDLESS_PAYMENT_SUCCESS';
export const RETRY_GOCARDLESS_PAYMENT_FAILURE =
  'tenancy/detail/RETRY_GOCARDLESS_PAYMENT_FAILURE';

export const REMOVE_GOCARDLESS_INVITATION =
  'tenancy/detail/REMOVE_GOCARDLESS_INVITATION';
export const REMOVE_GOCARDLESS_INVITATION_SUCCESS =
  'tenancy/detail/REMOVE_GOCARDLESS_INVITATION_SUCCESS';
export const REMOVE_GOCARDLESS_INVITATION_FAILURE =
  'tenancy/detail/REMOVE_GOCARDLESS_INVITATION_FAILURE';

export const REMOVE_GOCARDLESS_CUSTOMER =
  'tenancy/detail/REMOVE_GOCARDLESS_CUSTOMER';
export const REMOVE_GOCARDLESS_CUSTOMER_SUCCESS =
  'tenancy/detail/REMOVE_GOCARDLESS_CUSTOMER_SUCCESS';
export const REMOVE_GOCARDLESS_CUSTOMER_FAILURE =
  'tenancy/detail/REMOVE_GOCARDLESS_CUSTOMER_FAILURE';

export const VOID_GOCARDLESS_INVITATION_WARNINGS =
  'tenancy/detail/VOID_GOCARDLESS_INVITATION_WARNINGS';
export const VOID_GOCARDLESS_INVITATION_WARNINGS_SUCCESS =
  'tenancy/detail/VOID_GOCARDLESS_INVITATION_WARNINGS_SUCCESS';
export const VOID_GOCARDLESS_INVITATION_WARNINGS_FAILURE =
  'tenancy/detail/VOID_GOCARDLESS_INVITATION_WARNINGS_FAILURE';

export const FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS =
  'tenancy/detail/FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS';
export const FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS_SUCCESS =
  'tenancy/detail/FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS_SUCCESS';
export const FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS_FAILURE =
  'tenancy/detail/FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS_FAILURE';

export const SEND_GOCARDLESS_INVITATION =
  'tenancy/detail/SEND_GOCARDLESS_INVITATION';
export const SEND_GOCARDLESS_INVITATION_SUCCESS =
  'tenancy/detail/SEND_GOCARDLESS_INVITATION_SUCCESS';
export const SEND_GOCARDLESS_INVITATION_FAILURE =
  'tenancy/detail/SEND_GOCARDLESS_INVITATION_FAILURE';

export const ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING =
  'tenancy/detail/ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING';
export const ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING_SUCCESS =
  'tenancy/detail/ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING_SUCCESS';
export const ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING_FAILURE =
  'tenancy/detail/ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING_FAILURE';

export const ATTACH_GOCARDLESS_INVITATION_TO_BOOKING =
  'tenancy/detail/ATTACH_GOCARDLESS_INVITATION_TO_BOOKING';
export const ATTACH_GOCARDLESS_INVITATION_TO_BOOKING_SUCCESS =
  'tenancy/detail/ATTACH_GOCARDLESS_INVITATION_TO_BOOKING_SUCCESS';
export const ATTACH_GOCARDLESS_INVITATION_TO_BOOKING_FAILURE =
  'tenancy/detail/ATTACH_GOCARDLESS_INVITATION_TO_BOOKING_FAILURE';

export const fetchTenancy = createFetchAction({
  name: 'FETCH_TENANCY',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {
      tenancyId,
      extraActions
    }
  }),
  stateKey: 'tenancy'
});

export const fetchSchedule = ({scheduleType, tenancyId}, extraActions = []) => {
  if (scheduleType === SCHEDULE_TYPES.RENT) {
    return fetchRentSchedule({tenancyId, scheduleType}, extraActions);
  }
  if (scheduleType === SCHEDULE_TYPES.DEPOSIT) {
    return fetchDepositSchedule({tenancyId, scheduleType}, extraActions);
  }
  if (scheduleType === SCHEDULE_TYPES.ONE_OFF_CHARGE) {
    return fetchOneOffSchedule({tenancyId, scheduleType, extraActions});
  }
  throw Error(`Schedule type is not recognised: ${scheduleType}`);
};

export const fetchRentSchedule = createFetchAction({
  name: 'FETCH_RENT_SCHEDULE',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {tenancyId, scheduleType: SCHEDULE_TYPES.RENT, extraActions}
  }),
  stateKey: 'schedules.rent'
});

export const fetchDepositSchedule = createFetchAction({
  name: 'FETCH_DEPOSIT_SCHEDULE',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {tenancyId, scheduleType: SCHEDULE_TYPES.DEPOSIT, extraActions}
  }),
  stateKey: 'schedules.deposit'
});

export const fetchOneOffSchedule = createFetchAction({
  name: 'FETCH_ONE_OFF_SCHEDULE',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {
      tenancyId,
      scheduleType: SCHEDULE_TYPES.ONE_OFF_CHARGE,
      extraActions
    }
  }),
  stateKey: 'schedules.oneOffCharge'
});

export const fetchInvoice = createFetchAction({
  name: 'FETCH_INVOICE',
  initialAction: ({invoiceId}, extraActions = []) => ({
    payload: {
      invoiceId,
      extraActions
    }
  })
});

export const fetchDraftInvoice = createFetchAction({
  name: 'FETCH_DRAFT_INVOICE',
  initialAction: ({draftInvoiceId}, extraActions = []) => ({
    payload: {
      draftInvoiceId,
      extraActions
    }
  })
});

export const addPayment = createPostAction({
  name: 'ADD_PAYMENT',
  initialAction: (
    {
      invoice,
      amount,
      datePaid,
      paidTo,
      reference,
      tenancyId,
      overpaymentDescription,
      batchNumber,
      creditCardNumber,
      colabAccountType
    },
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      invoice,
      amount,
      datePaid,
      paidTo,
      reference,
      overpaymentDescription,
      tenancyId,
      batchNumber,
      creditCardNumber,
      colabAccountType,
      successExtraActions,
      failureExtraActions
    }
  }),
  formName: 'receivePayment'
});

export const fetchCreditNote = createFetchAction({
  name: 'FETCH_CREDIT_NOTE',
  initialAction: ({creditNoteId}, extraActions = []) => ({
    payload: {
      creditNoteId,
      extraActions
    }
  })
});

export const addRefund = createPostAction({
  name: 'ADD_REFUND',
  initialAction: (
    {creditNote, amount, datePaid, paidTo, reference, tenancyId},
    extraActions = []
  ) => ({
    payload: {
      creditNote,
      amount,
      datePaid,
      paidTo,
      reference,
      tenancyId,
      extraActions
    }
  }),
  formName: 'receiveCashRefund'
});

export const fetchPayment = createFetchAction({
  name: 'FETCH_PAYMENT',
  initialAction: ({paymentId}, extraActions = []) => ({
    payload: {
      paymentId,
      extraActions
    }
  })
});

export const getNextFreeIdCounter = createPostAction({
  name: 'GET_NEXT_FREE_ID_COUNTER',
  initialAction: ({tenancyId, objectType}, extraActions = []) => ({
    payload: {
      tenancyId,
      objectType,
      extraActions
    }
  })
});

export const fetchXeroAccounts = createFetchAction({
  name: 'FETCH_XERO_ACCOUNTS',
  initialAction: ({location, accountType}, extraActions = []) => ({
    payload: {
      location,
      accountType,
      extraActions
    }
  })
});

export const fetchXeroTaxRates = createFetchAction({
  name: 'FETCH_XERO_TAX_RATES',
  initialAction: ({filters}, extraActions = []) => ({
    payload: {
      filters,
      extraActions
    }
  })
});

export const fetchRoomAllocations = createFetchAction({
  name: 'FETCH_ROOM_ALLOCATIONS',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {
      tenancyId,
      extraActions
    }
  }),
  stateKey: 'roomAllocations'
});

export const roomMove = createPostAction({
  name: 'ROOM_MOVE',
  initialAction: (
    {
      moveInDate,
      moveInHour,
      vacateDate,
      vacateHour,
      allocation,
      booking,
      room,
      cleanupPeriodDays,
      locationRef,
      reason
    },
    extraActions = []
  ) => ({
    payload: {
      moveInDate,
      moveInHour,
      vacateDate,
      vacateHour,
      allocation,
      booking,
      room,
      cleanupPeriodDays,
      locationRef,
      reason,
      extraActions
    }
  }),
  formName: 'roomMove'
});

export const createInvoice = createPostAction({
  name: 'CREATE_INVOICE',
  initialAction: (
    {
      idCounter,
      unitPrice,
      quantity,
      discount,
      taxRate,
      description,
      reference,
      account,
      dueDate,
      start,
      end,
      dateIssued,
      location,
      tenancyId,
      scheduleType
    },
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      idCounter,
      unitPrice,
      quantity,
      discount,
      taxRate,
      description,
      reference,
      account,
      dueDate,
      start,
      end,
      dateIssued,
      location,
      tenancyId,
      scheduleType,
      successExtraActions,
      failureExtraActions
    }
  }),
  formName: 'invoiceCreate'
});

export const createDraftInvoice = createPostAction({
  name: 'CREATE_DRAFT_INVOICE',
  initialAction: (
    {
      location,
      xeroTaxRate,
      xeroAccount,
      dateIssued,
      dueDate,
      rentReference,
      rentStart,
      rentEnd,
      itemDescription,
      quantity,
      unitPrice,
      schedule
    },
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      location,
      xeroTaxRate,
      xeroAccount,
      dateIssued,
      dueDate,
      rentReference,
      rentStart,
      rentEnd,
      itemDescription,
      quantity,
      unitPrice,
      schedule,
      successExtraActions,
      failureExtraActions
    }
  }),
  formName: 'createDraftInvoice'
});

export const createCreditNote = createPostAction({
  name: 'CREATE_CREDIT_NOTE',
  initialAction: (
    {
      idCounter,
      quantity,
      unitPrice,
      discount,
      taxRate,
      account,
      description,
      dateIssued,
      rentStart,
      rentEnd,
      reference,
      location,
      tenancyId,
      scheduleType,
      invoice = null
    },
    extraActions = []
  ) => ({
    payload: {
      idCounter,
      quantity,
      unitPrice,
      discount,
      taxRate,
      account,
      description,
      dateIssued,
      rentStart,
      rentEnd,
      reference,
      location,
      tenancyId,
      scheduleType,
      invoice,
      extraActions
    }
  }),
  formName: 'creditNoteCreate'
});

export const fetchOverpayment = createFetchAction({
  name: 'FETCH_OVERPAYMENT',
  initialAction: ({overpaymentId}, extraActions = []) => ({
    payload: {
      overpaymentId,
      extraActions
    }
  })
});

export const fetchCanCreateFinanceItemForPastMonths = createFetchAction({
  name: 'FETCH_CAN_FINANCE_CREATE_ITEM_FOR_PAST_MONTHS',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {
      locationRef,
      extraActions
    }
  })
});

export const createOverpayment = createPostAction({
  name: 'CREATE_OVERPAYMENT',
  initialAction: (
    {amount, description, paymentDate, xeroAccount, scheduleType, tenancyId},
    extraActions = []
  ) => ({
    payload: {
      amount,
      description,
      paymentDate,
      xeroAccount,
      tenancyId,
      scheduleType,
      extraActions
    }
  }),
  formName: 'overpaymentCreate'
});

export const fetchXeroOrganisation = createFetchAction({
  name: 'FETCH_XERO_ORGANISATION',
  initialAction: ({locationRef}, extraActions) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'xeroOrganisation'
});

export const addRefundForOverpayment = createPostAction({
  name: 'ADD_REFUND_FOR_OVERPAYMENT',
  initialAction: (
    {amount, overpayment, paymentDate, reference, xeroAccount, tenancyId},
    extraActions = []
  ) => ({
    payload: {
      amount,
      overpayment,
      paymentDate,
      reference,
      xeroAccount,
      tenancyId,
      extraActions
    }
  }),
  formName: 'receiveCashRefundForOverpayment'
});

export const voidObject = createPostAction({
  name: 'VOID_OBJECT',
  initialAction: (
    {objectId, tenancyId, objectType, scheduleType},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      objectId,
      objectType,
      tenancyId,
      scheduleType,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const deallocateCreditNotes = createPostAction({
  name: 'DEALLOCATE_CREDIT_NOTES',
  initialAction: (
    {invoiceId, tenancyId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      invoiceId,
      tenancyId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const deallocateCreditNoteFromInvoice = createPostAction({
  name: 'DEALLOCATE_CREDIT_NOTE_FROM_INVOICE',
  initialAction: (
    {invoiceId, tenancyId, creditNoteId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      invoiceId,
      tenancyId,
      creditNoteId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const addXeroId = createPostAction({
  name: 'ADD_XERO_ID',
  initialAction: (
    {xeroId, objectId, objectType, scheduleType, tenancyId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      xeroId,
      objectId,
      objectType,
      tenancyId,
      scheduleType,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const syncWithXero = createPostAction({
  name: 'SYNC_WITH_XERO',
  initialAction: (
    {objectId, objectType, scheduleType, tenancyId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      objectId,
      objectType,
      tenancyId,
      scheduleType,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const recordBreakClauseNotice = (
  {givenDate, departureDate, tenancyId, warnings},
  successExtraActions,
  failureExtraActions
) => ({
  type: RECORD_BREAK_CLAUSE_NOTICE,
  payload: {
    givenDate,
    departureDate,
    tenancyId,
    warnings,
    successExtraActions,
    failureExtraActions
  }
});

export const recordBreakClauseNoticeSuccess = data => ({
  type: RECORD_BREAK_CLAUSE_NOTICE_SUCCESS,
  payload: data
});

export const recordBreakClauseNoticeFailure = warnings => ({
  type: RECORD_BREAK_CLAUSE_NOTICE_FAILURE,
  payload: {
    warnings
  }
});

export const fetchBreakClause = createFetchAction({
  name: 'FETCH_BREAK_CLAUSE',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {
      tenancyId,
      extraActions
    }
  }),
  stateKey: 'breakClause'
});

export const fetchInvoiceAllocatedCreditNotesXeroLinks = createFetchAction({
  name: 'FETCH_INVOICE_ALLOCATED_CREDIT_NOTES_XERO_LINKS',
  initialAction: ({tenancyId, invoiceId}, extraActions = []) => ({
    payload: {
      tenancyId,
      invoiceId,
      extraActions
    }
  })
});

export const fetchTerminationReasons = createFetchAction({
  name: 'FETCH_TERMINATION_REASONS',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {
      tenancyId,
      extraActions
    }
  })
});

export const predictTermination = createPostAction({
  name: 'PREDICT_TERMINATION',
  initialAction: (
    {
      tenancyId,
      reason,
      terminationDate,
      departureDate,
      notes,
      terminatedBeforeMoveIn
    },
    extraActions = []
  ) => ({
    payload: {
      tenancyId,
      reason,
      terminationDate,
      departureDate,
      notes,
      terminatedBeforeMoveIn,
      extraActions
    }
  }),
  formName: 'terminateTenancy'
});

export const ROOM_MOVE_FLOW = 'tenancy/detail/ROOM_MOVE_FLOW';
export const roomMoveFlow = ({
  locationRef,
  bookingId,
  roomType,
  startDate,
  startHour,
  endDate,
  modalName,
  cleanupPeriodDays
}) => ({
  type: ROOM_MOVE_FLOW,
  payload: {
    locationRef,
    roomType,
    bookingId,
    startDate,
    startHour,
    endDate,
    modalName,
    cleanupPeriodDays
  }
});

export const confirmTermination = createPostAction({
  name: 'CONFIRM_TERMINATION',
  initialAction: (
    {
      tenancyId,
      notes,
      reason,
      departureDate,
      terminationDate,
      terminatedBeforeMoveIn
    },
    extraActions = []
  ) => ({
    payload: {
      tenancyId,
      reason,
      terminationDate,
      departureDate,
      notes,
      terminatedBeforeMoveIn,
      extraActions
    }
  }),
  stateKey: 'tenancyTermination'
});
export const selectTerminatingTenancy = createPostSelectors(confirmTermination)
  .isLoading;

export const moveEntireBooking = createPostAction({
  name: 'MOVE_ENTIRE_BOOKING',
  initialAction: (
    {locationRef, booking, newRoom, createCleanup, cleanupPeriodDays},
    extraActions = []
  ) => ({
    payload: {
      locationRef,
      booking,
      newRoom,
      createCleanup,
      cleanupPeriodDays,
      extraActions
    }
  }),
  formName: 'roomMove'
});

export const getMoveRoomOverlap = createPostAction({
  name: 'GET_MOVE_ROOM_OVERLAP',
  initialAction: (
    {locationRef, moveInDate, moveInHour, vacateDate, vacateHour},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      locationRef,
      moveInDate,
      moveInHour,
      vacateDate,
      vacateHour,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const fetchEarlyTerminations = createFetchAction({
  name: 'FETCH_EARLY_TERMINATIONS',
  initialAction: ({tenancyId}, extraActions) => ({
    payload: {
      tenancyId,
      extraActions
    }
  }),
  stateKey: 'earlyTerminations'
});

export const deleteEarlyTermination = createPostAction({
  name: 'DELETE_EARLY_TERMINATION',
  initialAction: (
    {tenancyId, terminationId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      tenancyId,
      terminationId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const deleteDraftInvoice = createPostAction({
  name: 'DELETE_DRAFT_INVOICE',
  initialAction: (
    {draftInvoiceId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      draftInvoiceId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const approveDraftInvoice = createPostAction({
  name: 'APPROVE_DRAFT_INVOICE',
  initialAction: (
    {draftInvoiceId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      draftInvoiceId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const fetchGocardlessCustomer = createFetchAction({
  name: 'FETCH_GOCARDLESS_CUSTOMER',
  initialAction: ({gocardlessCustomerId}, extraActions = []) => ({
    payload: {
      gocardlessCustomerId,
      extraActions
    }
  })
});

export const fetchGocardlessCustomerPayments = createFetchAction({
  name: 'FETCH_GOCARDLESS_CUSTOMER_PAYMENTS',
  initialAction: ({gocardlessCustomerId}, extraActions = []) => ({
    payload: {
      gocardlessCustomerId,
      extraActions
    }
  })
});

export const fetchGocardlessCustomerAndInvitation = createFetchAction({
  name: 'FETCH_GOCARDLESS_CUSTOMER_AND_INVITATION',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {tenancyId, extraActions}
  }),
  stateKey: 'gocardlessCustomerAndInvitation',
  defaultStateValue: {
    currentGocardlessCustomer: null,
    currentGocardlessInvitation: null
  }
});

export const initiateGocardlessPayment = (
  {
    invoiceId,
    description,
    specifiedChargeDate
  }: any & {specifiedChargeDate?: string | null},
  extraActions = []
) => ({
  type: INITIATE_GOCARDLESS_PAYMENT,
  payload: {
    invoiceId,
    description,
    specifiedChargeDate,
    extraActions
  }
});

export const initiateGocardlessPaymentSuccess = data => ({
  type: INITIATE_GOCARDLESS_PAYMENT_SUCCESS,
  payload: {
    data
  }
});

export const initiateGocardlessPaymentFailure = errors => ({
  type: INITIATE_GOCARDLESS_PAYMENT_FAILURE,
  payload: {errors}
});

export const fetchGocardlessPayment = createFetchAction({
  name: 'FETCH_GOCARDLESS_PAYMENT',
  initialAction: ({gocardlessPaymentId}, extraActions = []) => ({
    payload: {
      gocardlessPaymentId,
      extraActions
    }
  })
});

export const fetchGocardlessPaymentEventsHistory = createFetchAction({
  name: 'FETCH_GOCARDLESS_PAYMENT_EVENTS_HISTORY',
  initialAction: ({gocardlessPaymentId}, extraActions = []) => ({
    payload: {
      gocardlessPaymentId,
      extraActions
    }
  })
});

export const fetchGoCardlessTenantsForBooking = createFetchAction({
  name: 'FETCH_GOCARDLESS_TENANTS_FOR_BOOKING',
  initialAction: ({bookingId}, extraActions = []) => ({
    payload: {
      bookingId,
      extraActions
    }
  })
});

export const fetchSendGocardlessInvitationWarnings = (
  {tenancyId, tenantId},
  successExtraActions,
  failureExtraActions
) => ({
  type: FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS,
  payload: {
    tenancyId,
    tenantId,
    successExtraActions,
    failureExtraActions
  }
});

export const fetchSendGoCardlessInvitationWarningsSuccess = data => ({
  type: FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS_SUCCESS,
  payload: {
    data
  }
});

export const fetchSendGoCardlessInvitationWarningsFailure = errors => ({
  type: FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS_FAILURE,
  payload: {errors}
});

export const sendGoCardlessInvitation = (
  {tenancyId, tenantId},
  successExtraActions,
  failureExtraActions
) => ({
  type: SEND_GOCARDLESS_INVITATION,
  payload: {
    tenancyId,
    tenantId,
    successExtraActions,
    failureExtraActions
  }
});

export const sendGoCardlessInvitationSuccess = data => ({
  type: SEND_GOCARDLESS_INVITATION_SUCCESS,
  payload: {
    data
  }
});

export const sendGoCardlessInvitationFailure = errors => ({
  type: SEND_GOCARDLESS_INVITATION_FAILURE,
  payload: {errors}
});

export const filterGoCardlessCustomers = (
  {locationRef, query},
  extraActions = []
) => ({
  type: FILTER_GOCARDLESS_CUSTOMERS,
  payload: {
    locationRef,
    query,
    extraActions
  }
});

export const filterGoCardlessCustomersSuccess = () => ({
  type: FILTER_GOCARDLESS_CUSTOMERS_SUCCESS,
  payload: {}
});

export const filterGoCardlessCustomersFailure = () => ({
  type: FILTER_GOCARDLESS_CUSTOMERS_FAILURE,
  payload: {}
});

export const filterGoCardlessActiveMandates = (
  {locationRef, customerId},
  extraActions = []
) => ({
  type: FILTER_GOCARDLESS_ACTIVE_MANDATES,
  payload: {
    locationRef,
    customerId,
    extraActions
  }
});

export const filterGoCardlessActiveMandatesSuccess = () => ({
  type: FILTER_GOCARDLESS_ACTIVE_MANDATES_SUCCESS,
  payload: {}
});

export const filterGoCardlessActiveMandatesFailure = () => ({
  type: FILTER_GOCARDLESS_ACTIVE_MANDATES_FAILURE,
  payload: {}
});

export const fetchLinkGoCardlessMandateToBookingWarnings = (
  {gocardlessCustomerId, gocardlessMandateId},
  extraActions
) => ({
  type: FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS,
  payload: {
    gocardlessCustomerId,
    gocardlessMandateId,
    extraActions
  }
});

export const fetchLinkGoCardlessMandateToBookingWarningsSuccess = () => ({
  type: FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS_SUCCESS,
  payload: {}
});

export const fetchLinkGoCardlessMandateToBookingWarningsFailure = () => ({
  type: FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS_FAILURE,
  payload: {}
});

export const connectGoCardlessCustomer = (
  {goCardlessCustomer, goCardlessMandate, tenant, tenancyId},
  extraActions: Array<any> = []
) => ({
  type: CONNECT_GOCARDLESS_CUSTOMER,
  payload: {
    goCardlessCustomer,
    goCardlessMandate,
    tenancyId,
    tenant,
    extraActions
  }
});
export const connectGoCardlessCustomerSuccess = () => ({
  type: CONNECT_GOCARDLESS_CUSTOMER_SUCCESS,
  payload: {}
});

export const connectGoCardlessCustomerFailure = () => ({
  type: CONNECT_GOCARDLESS_CUSTOMER_FAILURE,
  payload: {}
});

export const cancelGocardlessPayment = (
  {gocardlessPaymentId},
  extraActions = []
) => ({
  type: CANCEL_GOCARDLESS_PAYMENT,
  payload: {
    gocardlessPaymentId,
    extraActions
  }
});

export const cancelGocardlessPaymentSuccess = () => ({
  type: CANCEL_GOCARDLESS_PAYMENT_SUCCESS,
  payload: {}
});
export const cancelGocardlessPaymentFailure = () => ({
  type: CANCEL_GOCARDLESS_PAYMENT_FAILURE,
  payload: {}
});

export const retryGocardlessPayment = (
  {gocardlessPaymentId},
  extraActions = []
) => ({
  type: RETRY_GOCARDLESS_PAYMENT,
  payload: {
    gocardlessPaymentId,
    extraActions
  }
});

export const retryGocardlessPaymentSuccess = () => ({
  type: RETRY_GOCARDLESS_PAYMENT_SUCCESS,
  payload: {}
});
export const retryGocardlessPaymentFailure = () => ({
  type: RETRY_GOCARDLESS_PAYMENT_FAILURE,
  payload: {}
});

export const removeGocardlessInvitation = (
  {tenancyId, invitationId, voidInvitation},
  successExtraActions = [],
  failureExtraActions = []
) => ({
  type: REMOVE_GOCARDLESS_INVITATION,
  payload: {
    tenancyId,
    invitationId,
    voidInvitation,
    successExtraActions,
    failureExtraActions
  }
});

export const removeGocardlessInvitationSuccess = data => ({
  type: REMOVE_GOCARDLESS_INVITATION_SUCCESS,
  payload: data
});

export const removeGocardlessInvitationFailure = errors => ({
  type: REMOVE_GOCARDLESS_INVITATION_FAILURE,
  payload: errors
});

export const removeGocardlessCustomer = (
  {tenancyId, customerId},
  successExtraActions = [],
  failureExtraActions = []
) => ({
  type: REMOVE_GOCARDLESS_CUSTOMER,
  payload: {tenancyId, customerId, successExtraActions, failureExtraActions}
});

export const removeGocardlessCustomerSuccess = data => ({
  type: REMOVE_GOCARDLESS_CUSTOMER_SUCCESS,
  payload: data
});

export const removeGocardlessCustomerFailure = errors => ({
  type: REMOVE_GOCARDLESS_CUSTOMER_FAILURE,
  payload: errors
});

export const voidGocardlessInvitationWarnings = (
  {invitationId},
  extraActions = []
) => ({
  type: VOID_GOCARDLESS_INVITATION_WARNINGS,
  payload: {invitationId, extraActions}
});

export const voidGocardlessInvitationWarningsSuccess = data => ({
  type: VOID_GOCARDLESS_INVITATION_WARNINGS_SUCCESS,
  payload: data
});

export const voidGocardlessInvitationWarningsFailure = errors => ({
  type: VOID_GOCARDLESS_INVITATION_WARNINGS_FAILURE,
  payload: errors
});

export const cancelGocardlessCustomer = createPostAction({
  name: 'CANCEL_GOCARDLESS_CUSTOMER',
  initialAction: (
    {gocardlessCustomerId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      gocardlessCustomerId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const cancelGocardlessCustomerWarnings = createPostAction({
  name: 'CANCEL_GOCARDLESS_CUSTOMER_WARNINGS',
  initialAction: ({gocardlessCustomerId}, successExtraActions = []) => ({
    payload: {gocardlessCustomerId, successExtraActions}
  })
});

export const fetchNextPossibleChargeDate = createFetchAction({
  name: 'FETCH_NEXT_POSSIBLE_CHARGE_DATE',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {tenancyId, extraActions}
  })
});

export const fetchSuggestedGoCardlessCustomersAndInvitations = createFetchAction(
  {
    name: 'FETCH_SUGGESTED_GOCARDLESS_CUSTOMERS_AND_INVITATIONS',
    initialAction: ({tenancyId}, extraActions = []) => ({
      payload: {tenancyId, extraActions}
    })
  }
);

export const attachGoCardlessCustomerToBooking = (
  {tenancyId, goCardlessCustomer},
  extraActions
) => ({
  type: ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING,
  payload: {
    tenancyId,
    goCardlessCustomer,
    extraActions
  }
});

export const attachGoCardlessCustomerToBookingSuccess = data => ({
  type: ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING_SUCCESS,
  payload: data
});

export const attachGoCardlessCustomerToBookingFailure = errors => ({
  type: ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING_FAILURE,
  payload: errors
});

export const attachGoCardlessInvitationToBooking = (
  {tenancyId, goCardlessInvitation},
  extraActions
) => ({
  type: ATTACH_GOCARDLESS_INVITATION_TO_BOOKING,
  payload: {
    tenancyId,
    goCardlessInvitation,
    extraActions
  }
});

export const attachGoCardlessInvitationToBookingSuccess = data => ({
  type: ATTACH_GOCARDLESS_INVITATION_TO_BOOKING_SUCCESS,
  payload: data
});

export const attachGoCardlessInvitationToBookingFailure = errors => ({
  type: ATTACH_GOCARDLESS_INVITATION_TO_BOOKING_FAILURE,
  payload: errors
});

export const selectXeroOrganisation = createFetchSelectors(
  fetchXeroOrganisation
).data;

export const selectRoomAllocations = createFetchSelectors(fetchRoomAllocations)
  .data;

export const selectGocardlessCustomerAndInvitation = createFetchSelectors(
  fetchGocardlessCustomerAndInvitation
).data;

export const selectEarlyTerminations = createFetchSelectors(
  fetchEarlyTerminations
).data;

export const selectTenancy = createFetchSelectors(fetchTenancy).data;

export const selectRentSchedule = createFetchSelectors(fetchRentSchedule).data;
export const selectDepositSchedule = createFetchSelectors(fetchDepositSchedule)
  .data;
export const selectOneOffSchedule = createFetchSelectors(fetchOneOffSchedule)
  .data;

export const MODALS = {
  INVOICE_DETAIL: 'invoiceDetail',
  DRAFT_INVOICE_DETAIL: 'draftInvoiceDetail',
  CREDIT_NOTE_DETAIL: 'creditNoteDetail',
  PAYMENT_DETAIL: 'paymentDetail',
  INVOICE_CREATE: 'invoiceCreate',
  ROOM_MOVE: 'roomMove',
  OVERPAYMENT_DETAIL: 'overpaymentDetail',
  OVERPAYMENT_CREATE: 'overpaymentCreate',
  CREDIT_NOTE_CREATE: 'creditNoteCreate',
  BREAK_CLAUSE_NOTICE_RECORD: 'breakClauseNoticeRecord',
  REFUND_DETAIL: 'refundDetail',
  GOCARDLESS_CUSTOMER_DETAIL: 'gocardlessCustomerDetail',
  TERMINATE_TENANCY: 'terminateTenancy',
  GOCARDLESS_PAYMENT_DETAIL: 'gocardlessPaymentDetail',
  CONFIRM_TERMINATION: 'confirmTermination',
  INITIATE_GOCARDLESS_PAYMENT: 'initiateGoCardlessPayment',
  REMOVE_GOCARDLESS_INVITATION: 'removeGocardlessInvitation',
  REMOVE_AND_VOID_GOCARDLESS_INVITATION: 'removeAndVoidGocardlessInvitation',
  SETUP_GOCARDLESS: 'setupGocardless',
  SEND_GOCARDLESS_INVITATION_CONFIRM: 'sendGoCardlessInvitationConfirm',
  CANCEL_GOCARDLESS_CUSTOMER: 'cancelGocardlessCustomer',
  CONFIRM_PAYMENT: 'confirmPayment'
};

const initialState = {
  loading: true,
  xeroOrganisation: null,
  tenancy: null,
  breakClause: null,
  earlyTerminations: {data: []},
  schedules: {
    rent: {
      loading: true,
      error: null,
      data: {}
    },
    room: {
      loading: true,
      error: null,
      data: []
    },
    oneOffCharge: {
      loading: true,
      error: null,
      data: {}
    },
    deposit: {
      loading: true,
      error: null,
      data: {}
    }
  },
  roomAllocations: {
    data: []
  }
};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchTenancy),
  ...createFetchReducers(fetchRentSchedule),
  ...createFetchReducers(fetchDepositSchedule),
  ...createFetchReducers(fetchOneOffSchedule),
  ...createFetchReducers(fetchInvoice),
  ...createFetchReducers(fetchDraftInvoice),
  ...createFetchReducers(fetchCreditNote),
  ...createFetchReducers(fetchRoomAllocations),
  ...createFetchReducers(fetchXeroOrganisation),
  ...createFetchReducers(fetchBreakClause),
  ...createFetchReducers(fetchEarlyTerminations),
  ...createFetchReducers(fetchGocardlessCustomerAndInvitation),
  ...createFetchReducers(fetchInvoiceAllocatedCreditNotesXeroLinks),
  ...createPostReducers(confirmTermination)
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {tenancyDetailSaga} from './saga';
export * from './selectors';
